import { Flex, Text } from "rebass/styled-components";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledCommentsContainer = styled(Flex)`
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  width: 100%;

  @media (max-width: 1500px) {
    display: none;
  }
`;

export const ViewNowMobileButton = styled(Link)`
  background-color: ${({ theme }) => theme.colors.envy};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.ice};
  display: none;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s ease;
  width: 100%;

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.envyDark || theme.colors.envy};
    color: ${({ theme }) => theme.colors.ice};
    text-decoration: none;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

export const StyledHeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`;

export const StyledLogoSection = styled(Flex)`
  align-items: center;
  flex-direction: column;
  max-width: 400px;
  min-width: auto;
  width: 100%;
`;
